import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useB2cSchedule = (group_id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [scheduleList, setScheduleList] = useState<ProjectScheduleInfoDto[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const { isLoading, refetch } = useQuery(
    [endpoints.b2c.schedule.list, group_id],
    () =>
      fetcher.project.postB2cScheduleList({
        id: group_id,
      }),
    {
      onSuccess: (res: ProjectScheduleListResDto) => {
        switch (res.code) {
          case 200:
            setScheduleList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { scheduleList, refetch };
};

export default useB2cSchedule;
